"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GenericContent = require("./GenericContent");
Object.keys(_GenericContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GenericContent[key];
    }
  });
});
